import React from "react";
import { Parallax } from "react-parallax";
import bgImage from "../img/banner.jpg";

export default function Songs() {
	return (
		<div className="content">
			<div className="banner">
				<Parallax
					className="parallax"
					blur={0}
					bgImage={bgImage}
					bgImageAlt=""
					strength={300}
				>
					<h1>Songs</h1>
				</Parallax>
			</div>
			<h2>Festen kan börja</h2>
			<h5 className="food_text">
				<i>Mel: Vårvindar friska</i>
			</h5>
			<h4 className="food_text">Festen kan börja, </h4>
			<h4 className="food_text">ingen får sörja, </h4>
			<h4 className="food_text">här finns det både brännvin och mat. </h4>
			<h4 className="food_text">Helan ska tömmas, </h4>
			<h4 className="food_text">sorgerna glömmas, </h4>
			<h4 className="food_text">ingen får vara tråkig kamrat. </h4>
			<h4 className="food_text">Klappa mitt hjärta, </h4>
			<h4 className="food_text">fröjdas min själ, </h4>
			<h4 className="food_text">nubben serveras genast, nåväl. </h4>
			<h4 className="food_text">Nu tar vi supen, </h4>
			<h4 className="food_text">öppna på strupen, </h4>
			<h4 className="food_text">gästernas välkomstskål. </h4>
			<br></br>
			<h2>Teknologvisa</h2>
			<h5 className="food_text">
				<i>Mel: Lumberjack song</i>
			</h5>
			<br></br>
			<h5 className="food_text">Fetstilt sjungs av försångare</h5>
			<h4 className="food_text">
				<b>Jag är en teknolog och helt OK </b>
			</h4>
			<h4 className="food_text">
				<b>Jag jobbar hårt och jag roar mig </b>
			</h4>
			<br></br>
			<h4 className="food_text">Han är en teknolog och helt OK</h4>
			<h4 className="food_text">Han jobbar hårt och han roar sig</h4>
			<br></br>
			<h4 className="food_text">
				<b>Teknik är ball </b>
			</h4>
			<h4 className="food_text">
				<b>Jag kan Pascal </b>
			</h4>
			<h4 className="food_text">
				<b>Till STUK dit vill jag nu </b>
			</h4>
			<h4 className="food_text">
				<b>Där träffas alla vänner </b>
			</h4>
			<h4 className="food_text">
				<b>som är från LTU </b>
			</h4>
			<br></br>
			<h4 className="food_text">Teknik är ball </h4>
			<h4 className="food_text">Han kan Pascal </h4>
			<h4 className="food_text">Till STUK dit vill han nu </h4>
			<h4 className="food_text">Där träffas alla vänner </h4>
			<h4 className="food_text">som är från LTU </h4>
			<br></br>
			<h4 className="food_text">För han är en teknolog och helt OK </h4>
			<h4 className="food_text">Han jobbar hårt och han roar sig </h4>
			<br></br>
			<h4 className="food_text">
				<b>Min mattebok </b>
			</h4>
			<h4 className="food_text">
				<b>den gör mig klok </b>
			</h4>
			<h4 className="food_text">
				<b>Jag läser kärnfysik </b>
			</h4>
			<h4 className="food_text">
				<b>Jag går på föreläsning </b>
			</h4>
			<h4 className="food_text">
				<b>och älskar juridik </b>
			</h4>
			<br></br>
			<h4 className="food_text">Hans mattebok </h4>
			<h4 className="food_text">den gör han klok </h4>
			<h4 className="food_text">Han läser kärnfysik </h4>
			<h4 className="food_text">Han går på föreläsning </h4>
			<h4 className="food_text">och älskar juridik??? </h4>
			<br></br>
			<h4 className="food_text">Men han är teknolog och helt OK </h4>
			<h4 className="food_text">Han jobbar hårt och han roar sig </h4>
			<br></br>
			<h4 className="food_text">
				<b>Som ekonom </b>
			</h4>
			<h4 className="food_text">
				<b>jag blir fantom </b>
			</h4>
			<h4 className="food_text">
				<b>Konkurser gör mig säll </b>
			</h4>
			<h4 className="food_text">
				<b>Till flickor blankt jag nekar </b>
			</h4>
			<h4 className="food_text">
				<b>Jag älskar en tabell </b>
			</h4>
			<br></br>
			<h4 className="food_text">Som ekonom </h4>
			<h4 className="food_text">han blir fantom ??? </h4>
			<h4 className="food_text">konkurser… </h4>
			<h4 className="food_text">Nää, BUU!! </h4>
			<br></br>
			<h4 className="food_text">Men han är en teknolog och helt OK </h4>
			<h4 className="food_text">Han jobbar hårt och han roar sig </h4>
			<br></br>
			<h2>I natt jag drömde</h2>
			<h5 className="food_text">
				<i>Mel: I natt jag drömde</i>
			</h5>
			<h4 className="food_text">Inatt jag drömde något som </h4>
			<h4 className="food_text">jag aldrig drömt förut. </h4>
			<h4 className="food_text">Jag drömde det var strejk på Pripps </h4>
			<h4 className="food_text">och alla ölen var slut. </h4>
			<h4 className="food_text">Jag drömde om en jättesal </h4>
			<h4 className="food_text">där ölen stod på rad. </h4>
			<h4 className="food_text">Jag drack sådär en femton bärs </h4>
			<h4 className="food_text">och reste mig och sa: </h4>
			<h4 className="food_text">Det finns inga blå burkar mer </h4>
			<h4 className="food_text">nej inte en endaste bärs </h4>
			<h4 className="food_text">och de som hörde på dem sa </h4>
			<h4 className="food_text">att detta blir en pärs. </h4>
			<h4 className="food_text">På gatorna gick folk omkring </h4>
			<h4 className="food_text">och drog från krog till krog. </h4>
			<h4 className="food_text">Och alla vråla de av törst </h4>
			<h4 className="food_text">och svimmade och dog </h4>
			<br></br>
			<h2>Vit vecka</h2>
			<h5 className="food_text">
				<i>Mel: White christmas</i>
			</h5>
			<br></br>
			<h4 className="food_text">Jag drömmer om en vit vecka, </h4>
			<h4 className="food_text">sju dagar utan alkohol. </h4>
			<h4 className="food_text">Tänk att bara skåla </h4>
			<h4 className="food_text">i juice och cola </h4>
			<h4 className="food_text">och sedan minnas allt man gjort. </h4>
			<br></br>
			<h4 className="food_text">Jag drömmer om en vit vecka, </h4>
			<h4 className="food_text">det finns en gräns för vad jag tål. </h4>
			<h4 className="food_text">Jag vill inte dricka mera sprit </h4>
			<h4 className="food_text">så låt nästa vecka vara vit. </h4>
			<br></br>
			<h2>Kräftorna sköna</h2>
			<h5 className="food_text">
				<i>Mel: Vårvindar friska</i>
			</h5>
			<h4 className="food_text">Kräftorna sköna </h4>
			<h4 className="food_text">dillkronor gröna </h4>
			<h4 className="food_text">lysa så grant bland blommor och bla’r. </h4>
			<h4 className="food_text">Nubbarna ila </h4>
			<h4 className="food_text">finns ej vila </h4>
			<h4 className="food_text">förrän i magen störtvågen far. </h4>
			<h4 className="food_text">Gläd dig min mage </h4>
			<h4 className="food_text">hålla dig beredd, </h4>
			<h4 className="food_text">Helan vi tage </h4>
			<h4 className="food_text">på längd och bredd. </h4>
			<h4 className="food_text">Och lilla snapsen </h4>
			<h4 className="food_text">dyker så rapp sen </h4>
			<h4 className="food_text">ner i sin sköna bädd </h4>
			<br></br>
			<h2>Spritbolaget</h2>
			<h5 className="food_text">
				<i>Mel: Snickerboa</i>
			</h5>
			<h4 className="food_text">Till spritbolaget ränner jag och bankar på dess port. </h4>
			<h4 className="food_text">
				Jag vill ha nå´t som bränner bra och gör mig sketfull fort.{" "}
			</h4>
			<h4 className="food_text">Expediten sade: “Godda’, </h4>
			<h4 className="food_text">hur gammal kan min herre va’? </h4>
			<h4 className="food_text">Har du nå´t leg ditt fula drägg? </h4>
			<h4 className="food_text">Kom hit igen när du fått skägg!” </h4>
			<h4 className="food_text">Nej, detta var ju inte bra, jag vill bli full ikväll. </h4>
			<h4 className="food_text">Då plötsligt en idé jag fick, dom har ju sprit på Shell. </h4>
			<h4 className="food_text">Många flaskor stod där på rad, </h4>
			<h4 className="food_text">så nu kan jag bli full och glad. </h4>
			<h4 className="food_text">Den röda drycken åkte ner, </h4>
			<h4 className="food_text">nu kan jag inte se nå mer! </h4>
		</div>
	);
}
